import { Chip, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

type ThroughTicketTagProps = {
  disabled?: boolean
}

export const ThroughTicketTag: Organism<ThroughTicketTagProps> = ({
  disabled,
}) => {
  const { t } = useTranslation('consoleItems')
  return (
    <Chip
      label={
        <Typography variant="overline" color="white">
          {t('throughTicket', '通し券')}
        </Typography>
      }
      sx={{
        bgcolor: disabled ? 'grey.300' : 'secondary.main',
        px: 1,
        borderRadius: '2px',
        height: 20,
        '.MuiChip-label': { px: 0, py: 0, lineHeight: '20px' },
      }}
    />
  )
}
